import config from '@/config'
import { ajax } from 'gkSrc/utils/request'

export default {
  /**
   * 获取大事件
   * @see https://yapi.geekbang.org/project/116/interface/api/19570
   * @see https://yapi.geekbang.org/project/116/interface/api/1233 字段参考
   */
  getBigEvents () {
    return ajax({
      host: config.infoQHost,
      url: '/public/v1/article/get_geek_list'
    })
  }
}
